import React from "react";
import { FormattedMessage } from "react-intl";
import { Cancel } from "../../../../components/Form";
import { IProps } from "./interfaces";

export default ({ limit, close }: IProps) => (
    <div>
        <p>
            <FormattedMessage id="maximumTestsReached" values={{ limit }} />
        </p>
        <Cancel onClick={close}>
            <FormattedMessage id="general.close" />
        </Cancel>
    </div>
);
